import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  container: css`
    height: 76px;
    margin-top: 16px;
    margin-bottom: 40px;
    border-radius: 5px;
    border: 1px solid ${colors.silver};
    padding: 16px;
    cursor: pointer;
    user-select: none; /* supported by Chrome and Opera */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    box-shadow: 0 1px 0px 0 rgba(0, 0, 0, 0.2), 0 4px 8px 3px rgba(0, 0, 0, 0.1) !important;
  `,
};

export default styles;
